/* eslint-disable import/prefer-default-export */
export const MODAL_SIZE_GUIDE = 'size-guide-modal';
export const US_SIZE_LABEL = 'UNITED STATES';
